import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { SHIPPINGS } from '../constants'

const deleteShipping = async (id: number) => {
  await fetchAPI({
    path: `/shippings/${id}`,
    method: 'delete',
  })
}

export const useDeleteShipping = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteShipping, {
    async onSuccess() {
      await queryClient.refetchQueries([SHIPPINGS])

      toast({
        description: t('views.admin.shipping.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
